import { useDefaultTemplatesApptCounts } from '../../../../../hooks/apptTemplate/useDefaultTemplatesApptCounts';
import { WeeklyApptCountsCard } from './WeeklyApptCountsCard';

export const DefaultTemplateApptCountsCard = ({
  showOnlineMustBeShown,
  isLoading,
  selectedDate,
}: {
  showOnlineMustBeShown: boolean;
  isLoading: boolean;
  selectedDate: Date;
}) => {
  const { isFetching: isDefaultTemplatesApptCountsFetching, templateCounts } =
    useDefaultTemplatesApptCounts();

  const isFetching = isLoading || isDefaultTemplatesApptCountsFetching;

  return (
    <WeeklyApptCountsCard
      selectedDate={selectedDate}
      showOnlineMustBeShown={showOnlineMustBeShown}
      isLoading={isFetching}
      templateCounts={templateCounts}
    />
  );
};
